import ScalarIconCheck_vue_vue_type_script_setup_true_lang_default from "./ScalarIconCheck.vue_vue_type_script_setup_true_lang.js";
//#region src/components/ScalarIconCheck.vue
var ScalarIconCheck_default = ScalarIconCheck_vue_vue_type_script_setup_true_lang_default;
//#endregion
export { ScalarIconCheck_default as default };

//# sourceMappingURL=ScalarIconCheck.js.map